import { FC } from 'react'

const RecommendMentorPostIcon: FC = () => {
  return (
    <svg
      width="41"
      height="41"
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <desc>질문 등록 아이콘</desc>
      <g clipPath="url(#clip0_983_155)">
        <path
          d="M20.5 40.5C31.5457 40.5 40.5 31.5457 40.5 20.5C40.5 9.4543 31.5457 0.5 20.5 0.5C9.4543 0.5 0.5 9.4543 0.5 20.5C0.5 31.5457 9.4543 40.5 20.5 40.5Z"
          fill="white"
          stroke="#EEEEEE"
        />
        <path
          d="M24.592 28.25L25.968 26.706L26.402 26.591C27.1471 26.3918 27.8055 25.9522 28.2753 25.3405C28.745 24.7288 28.9998 23.9792 29 23.208V16C29 14.07 27.43 12.5 25.5 12.5H15.5C13.57 12.5 12 14.07 12 16V23.208C12 25.138 13.57 26.708 15.5 26.708H23.217L24.592 28.25ZM24.592 30C24.4509 30.0003 24.3114 29.9707 24.1827 29.9132C24.0539 29.8556 23.9388 29.7713 23.845 29.666L22.545 28.208H15.5C14.1739 28.208 12.9021 27.6812 11.9645 26.7435C11.0268 25.8059 10.5 24.5341 10.5 23.208V16C10.5 14.6739 11.0268 13.4021 11.9645 12.4645C12.9021 11.5268 14.1739 11 15.5 11H25.5C26.8261 11 28.0979 11.5268 29.0355 12.4645C29.9732 13.4021 30.5 14.6739 30.5 16V23.208C30.5 24.31 30.1362 25.3811 29.465 26.255C28.7937 27.129 27.8527 27.7568 26.788 28.041L25.338 29.666C25.2443 29.7712 25.1294 29.8554 25.0008 29.913C24.8722 29.9705 24.7329 30.0002 24.592 30Z"
          fill="#01A0FF"
        />
        <path
          d="M26.5 11.5H14.5C12.8431 11.5 11.5 12.8431 11.5 14.5V24.5C11.5 26.1569 12.8431 27.5 14.5 27.5H26.5C28.1569 27.5 29.5 26.1569 29.5 24.5V14.5C29.5 12.8431 28.1569 11.5 26.5 11.5Z"
          fill="#01A0FF"
        />
        <path
          d="M22.6372 26.4238L24.5622 29.1288L26.6472 26.4238H22.6372Z"
          fill="#01A0FF"
        />
        <path
          d="M20.2151 20.2727H21.3742L22.3457 21.5511L22.6014 21.892L24.0503 23.8182H22.8912L21.9367 22.5398L21.698 22.2159L20.2151 20.2727ZM24.4082 18.6364C24.4082 19.5568 24.2421 20.3523 23.9097 21.0227C23.5773 21.6932 23.1213 22.2102 22.5418 22.5739C21.9622 22.9375 21.3003 23.1193 20.556 23.1193C19.8117 23.1193 19.1497 22.9375 18.5702 22.5739C17.9906 22.2102 17.5347 21.6932 17.2023 21.0227C16.8699 20.3523 16.7037 19.5568 16.7037 18.6364C16.7037 17.7159 16.8699 16.9205 17.2023 16.25C17.5347 15.5795 17.9906 15.0625 18.5702 14.6989C19.1497 14.3352 19.8117 14.1534 20.556 14.1534C21.3003 14.1534 21.9622 14.3352 22.5418 14.6989C23.1213 15.0625 23.5773 15.5795 23.9097 16.25C24.2421 16.9205 24.4082 17.7159 24.4082 18.6364ZM23.3855 18.6364C23.3855 17.8807 23.2591 17.2429 23.0063 16.723C22.7563 16.2031 22.4168 15.8097 21.9878 15.5426C21.5617 15.2756 21.0844 15.142 20.556 15.142C20.0276 15.142 19.5489 15.2756 19.1199 15.5426C18.6938 15.8097 18.3543 16.2031 18.1014 16.723C17.8514 17.2429 17.7264 17.8807 17.7264 18.6364C17.7264 19.392 17.8514 20.0298 18.1014 20.5497C18.3543 21.0696 18.6938 21.4631 19.1199 21.7301C19.5489 21.9972 20.0276 22.1307 20.556 22.1307C21.0844 22.1307 21.5617 21.9972 21.9878 21.7301C22.4168 21.4631 22.7563 21.0696 23.0063 20.5497C23.2591 20.0298 23.3855 19.392 23.3855 18.6364Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_983_155">
          <rect width="41" height="41" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default RecommendMentorPostIcon
